import { formatDateParam, makeRequest } from "../lib/makeRequest";

export const customer_profile_overall = (data) => {
  const params = { coveredDate: formatDateParam(data.dates.from) };
  return makeRequest("/customer-profiles/overall", params);
};

export const customer_profile_cluster = (data) => {
  const params = { coveredDate: formatDateParam(data.dates.from) };

  return makeRequest(`/customer-profiles/cluster/${data.clusterId}`, params);
};

export const customer_profile_area = (data) => {
  const params = { coveredDate: formatDateParam(data.dates.from) };

  return makeRequest(`/customer-profiles/area/${data.areaId}`, params);
};

export const customer_profile_branch = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append("coveredDate", formatDateParam(data.dates.from));
  return makeRequest(
    `/customer-profiles/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};

export const customer_daily_profile_overall = (data) => {
  const params = { from: data.dates.from, to: data.dates.to };
  return makeRequest("/daily-customer-profiles/overall", params);
};

export const customer_daily_profile_cluster = (data) => {
  const params = { from: data.dates.from, to: data.dates.to };
  return makeRequest(
    `/daily-customer-profiles/cluster/${data.clusterId}`,
    params
  );
};

export const customer_daily_profile_area = (data) => {
  const params = { from: data.dates.from, to: data.dates.to };
  return makeRequest(`/daily-customer-profiles/area/${data.areaId}`, params);
};

export const customer_daily_profile_branch = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append("from", data.dates.from);
  urlParams.append("to", data.dates.to);
  return makeRequest(
    `/daily-customer-profiles/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};
